import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({
  eventPartnerContainer: {
    overflowX: 'auto',
    [theme.breakpoints.down('md')]: {
      flexWrap: 'nowrap',
      margin: '0 -1.5rem',
      width: 'auto',
      paddingLeft: pxToRem(16),
    },
  },
  title: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(5),
    },
  },
  eventPartnerCard: {
    '&:hover': {
      transition: 'box-shadow .3s',
      boxShadow: theme.shadows[1],
    },
    '& .eventDate': {
      color: theme.mixins.DarkTurquoise(),
    },
    [theme.breakpoints.down('md')]: {
      flex: '0 0 80%',
    },

    padding: `0 ${pxToRem(8)}`,
    [theme.breakpoints.up('lg')]: {
      padding: `0 ${pxToRem(6)}`,
      marginBottom: pxToRem(24),
    },
    '& .imageWrap, & img': {
      maxHeight: pxToRem(144),
      [theme.breakpoints.up('lg')]: {
        maxHeight: pxToRem(235),
      },
    },
  },
}));

export default useStyles;
